import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "search-container"
};
import { onMounted, reactive, ref } from 'vue';
import RoleHeader from './RoleHeader.vue';
import RoleList from './RoleList.vue';
import ChatRoleForm from '@/views/aip/model/chatRole/ChatRoleForm.vue';
import RoleCategoryList from './RoleCategoryList.vue';
import { ChatRoleApi } from '@/api/ai/model/chatRole';
import { ChatConversationApi } from '@/api/ai/chat/conversation';
import { Search } from '@element-plus/icons-vue';
import { useRouter } from 'vue-router';
import Icon from '@/components/Icon/src/Icon.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'RoleRepository',
  setup(__props) {
    const router = useRouter(); // 路由对象
    // 属性定义
    const loading = ref(false); // 加载中
    const activeTab = ref('my-role'); // 选中的角色 Tab
    const search = ref(''); // 加载中
    const myRoleParams = reactive({
      pageNo: 1,
      pageSize: 50
    });
    const myRoleList = ref([]); // my 分页大小
    const publicRoleParams = reactive({
      pageNo: 1,
      pageSize: 50
    });
    const publicRoleList = ref([]); // public 分页大小
    const activeCategory = ref('全部'); // 选择中的分类
    const categoryList = ref([]); // 角色分类类别
    /** tabs 点击 */
    const handleTabsClick = async tab => {
      // 设置切换状态
      activeTab.value = tab.paneName + '';
      // 切换的时候重新加载数据
      await getActiveTabsRole();
    };
    /** 获取 my role 我的角色 */
    const getMyRole = async append => {
      const params = {
        ...myRoleParams,
        name: search.value,
        publicStatus: false
      };
      const {
        list
      } = await ChatRoleApi.getMyPage(params);
      if (append) {
        myRoleList.value.push.apply(myRoleList.value, list);
      } else {
        myRoleList.value = list;
      }
    };
    /** 获取 public role 公共角色 */
    const getPublicRole = async append => {
      const params = {
        ...publicRoleParams,
        category: activeCategory.value === '全部' ? '' : activeCategory.value,
        name: search.value,
        publicStatus: true
      };
      const {
        total,
        list
      } = await ChatRoleApi.getMyPage(params);
      if (append) {
        publicRoleList.value.push.apply(publicRoleList.value, list);
      } else {
        publicRoleList.value = list;
      }
    };
    /** 获取选中的 tabs 角色 */
    const getActiveTabsRole = async () => {
      if (activeTab.value === 'my-role') {
        myRoleParams.pageNo = 1;
        await getMyRole();
      } else {
        publicRoleParams.pageNo = 1;
        await getPublicRole();
      }
    };
    /** 获取角色分类列表 */
    const getRoleCategoryList = async () => {
      categoryList.value = ['全部', ...(await ChatRoleApi.getCategoryList())];
    };
    /** 处理分类点击 */
    const handlerCategoryClick = async category => {
      // 切换选择的分类
      activeCategory.value = category;
      // 筛选
      await getActiveTabsRole();
    };
    /** 添加/修改操作 */
    const formRef = ref();
    const handlerAddRole = async () => {
      formRef.value.open('my-create', null, '添加角色');
    };
    /** 编辑角色 */
    const handlerCardEdit = async role => {
      formRef.value.open('my-update', role.id, '编辑角色');
    };
    /** 添加角色成功 */
    const handlerAddRoleSuccess = async e => {
      // 刷新数据
      await getActiveTabsRole();
    };
    /** 删除角色 */
    const handlerCardDelete = async role => {
      await ChatRoleApi.deleteMy(role.id);
      // 刷新数据
      await getActiveTabsRole();
    };
    /** 角色分页：获取下一页 */
    const handlerCardPage = async type => {
      try {
        loading.value = true;
        if (type === 'public') {
          publicRoleParams.pageNo++;
          await getPublicRole(true);
        } else {
          myRoleParams.pageNo++;
          await getMyRole(true);
        }
      } finally {
        loading.value = false;
      }
    };
    /** 选择 card 角色：新建聊天对话 */
    const handlerCardUse = async role => {
      // 1. 创建对话
      const data = {
        roleId: role.id
      };
      const conversationId = await ChatConversationApi.createChatConversationMy(data);
      // 2. 跳转页面
      await router.push({
        name: 'AiChat',
        query: {
          conversationId: conversationId
        }
      });
    };
    /** 初始化 **/
    onMounted(async () => {
      // 获取分类
      await getRoleCategoryList();
      // 获取 role 数据
      await getActiveTabsRole();
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createBlock(_component_el_container, {
        class: "role-container"
      }, {
        default: _withCtx(() => [_createVNode(ChatRoleForm, {
          ref_key: "formRef",
          ref: formRef,
          onSuccess: handlerAddRoleSuccess
        }, null, 512), _createVNode(RoleHeader, {
          title: "角色仓库",
          class: "relative"
        }), _createVNode(_component_el_main, {
          class: "role-main"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input, {
            loading: loading.value,
            modelValue: search.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.value = $event),
            class: "search-input",
            size: "default",
            placeholder: "请输入搜索的内容",
            "suffix-icon": _unref(Search),
            onChange: getActiveTabsRole
          }, null, 8, ["loading", "modelValue", "suffix-icon"]), activeTab.value == 'my-role' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: handlerAddRole,
            class: "ml-20px"
          }, {
            default: _withCtx(() => [_createVNode(Icon, {
              icon: "ep:user",
              style: {
                "margin-right": "5px"
              }
            }), _cache[4] || (_cache[4] = _createTextVNode(" 添加角色 "))]),
            _: 1
          })) : _createCommentVNode("", true)]), _createVNode(_component_el_tabs, {
            modelValue: activeTab.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => activeTab.value = $event),
            class: "tabs",
            onTabClick: handleTabsClick
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              class: "role-pane",
              label: "我的角色",
              name: "my-role"
            }, {
              default: _withCtx(() => [_createVNode(RoleList, {
                loading: loading.value,
                "role-list": myRoleList.value,
                "show-more": true,
                onOnDelete: handlerCardDelete,
                onOnEdit: handlerCardEdit,
                onOnUse: handlerCardUse,
                onOnPage: _cache[1] || (_cache[1] = $event => handlerCardPage('my')),
                class: "mt-20px"
              }, null, 8, ["loading", "role-list"])]),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              label: "公共角色",
              name: "public-role"
            }, {
              default: _withCtx(() => [_createVNode(RoleCategoryList, {
                class: "role-category-list",
                "category-list": categoryList.value,
                active: activeCategory.value,
                onOnCategoryClick: handlerCategoryClick
              }, null, 8, ["category-list", "active"]), _createVNode(RoleList, {
                "role-list": publicRoleList.value,
                onOnDelete: handlerCardDelete,
                onOnEdit: handlerCardEdit,
                onOnUse: handlerCardUse,
                onOnPage: _cache[2] || (_cache[2] = $event => handlerCardPage('public')),
                class: "mt-20px",
                loading: ""
              }, null, 8, ["role-list"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      });
    };
  }
});